/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from 'axios'

function prepareParams(config) {
    const field =
        config.sortDirection === 'desc' ? `-${config.sort}` : config.sort

    const params = {
        page: config.page,
        include: config.include,
        sort: field,
        per_page: config.per_page
    }

    const filters = config.filters || {}

    if (filters.search) params.search = filters.search
    if (filters.type)   params.type   = filters.type
    if (filters.status) params.status = filters.status

    return params
}

export default {
    getEvents({ state, rootState, commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/events`, {
                    params: prepareParams(state.eventsConfig)
                })
                .then((response) => {
                    commit('setEvents', response.data.events)
                    resolve(response)
                })
                .catch(reject)
        })
    },

    getEvent({ rootState, commit }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/events/${id}`)
                .then((response) => {
                    commit('setEvent', response.data.event)
                    resolve(response)
                })
                .catch(reject)
        })
    },

    createEvent({ rootState }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.baseURL}/events`, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    updateEvent({ rootState }, { id, payload }) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/events/${id}`, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    deleteEvent({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${rootState.baseURL}/events/${id}`)
                .then(resolve)
                .catch(reject)
        })
    },

    publishEvent({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/events/${id}/publish`)
                .then(resolve)
                .catch(reject)
        })
    },

    unpublishEvent({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/events/${id}/unpublish`)
                .then(resolve)
                .catch(reject)
        })
    },

    cancelEvent({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/events/${id}/cancel`)
                .then(resolve)
                .catch(reject)
        })
    }
}
